import { Colors, Text } from '@rockalingua/ui';

import { Tab, TabsContainer } from './Tabs.styled';

export type TabItem<T extends string = string> = {
  value: T;
  label: string;
};

type TabsProps<T extends string = string> = {
  tabs: TabItem<T>[];
  activeTab: T;
  setActiveTab: (value: T) => void;
};

export default function Tabs<T extends string = string>({
  tabs,
  activeTab,
  setActiveTab,
}: TabsProps<T>) {
  return (
    <TabsContainer>
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;
        return (
          <Tab
            key={tab.value}
            $active={isActive}
            onClick={() => setActiveTab(tab.value)}
            type="button"
          >
            <Text
              variant={isActive ? 'dm-14-bold' : 'dm-14-medium'}
              color={
                isActive
                  ? Colors.MAIN_VARIANTS[60]
                  : Colors.NEUTRAL_VARIANTS[100]
              }
            >
              {tab.label}
            </Text>
          </Tab>
        );
      })}
    </TabsContainer>
  );
}
